module.exports = __webpack_public_path__ + "2ed9f56d37d5a75db22a900a861fc85f.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-16.svg
// module id = 564
// module chunks = 0